import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ReportTable } from "@/components/reports/ReportTable";

const COLS = [{ key: "source", label: "Agency / sheet" }, { key: "total", label: "Leads" }, { key: "active", label: "Active" }, { key: "site_visit", label: "Site visit" },
  { key: "booked", label: "Booked" }, { key: "lost", label: "Lost" }, { key: "conversion", label: "Conversion %", render: (v) => `${v}%` }];

// Google Sheets leads grouped by spreadsheet file name (agency), with an agency filter for the source table.
export const AgencyBreakdown = ({ params, agency, setAgency, version }) => {
  const [names, setNames] = useState([]);
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/reports/sub-sources").then((r) => setNames(r.data)).catch(() => {}); }, [version]);
  useEffect(() => {
    api.get("/reports/sources", { params: { ...params, group: "sub_source" } }).then((r) => setRows(r.data)).catch(() => setRows([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [version]);
  if (!names.length) return null;
  return (
    <div data-testid="report-agencies" className="space-y-3 mt-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="label-caps">Google Sheets agencies · by spreadsheet name</div>
        <select data-testid="report-agency-filter" value={agency} onChange={(e) => setAgency(e.target.value)}
          className="h-9 border border-[#E6E4DD] rounded-sm px-2 text-sm bg-white max-w-full">
          <option value="all">All agencies (source table)</option>
          {names.map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <ReportTable columns={COLS} rows={rows} testId="report-agencies-table" />
    </div>
  );
};
